import { render, staticRenderFns } from "./BrandTableDialog.vue?vue&type=template&id=7b7913bc&scoped=true"
import script from "./BrandTableDialog.vue?vue&type=script&lang=js"
export * from "./BrandTableDialog.vue?vue&type=script&lang=js"
import style0 from "./BrandTableDialog.vue?vue&type=style&index=0&id=7b7913bc&prod&lang=scss"
import style1 from "./BrandTableDialog.vue?vue&type=style&index=1&id=7b7913bc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7913bc",
  null
  
)

export default component.exports